import store from "@/store";
import { apiUrl } from "./fetchData";

export const MAX_UPLOAD_BYTES = 10 * 1024 * 1024;
export const ACCEPTED_DOCUMENTS =
  ".pdf,.docx,.txt,.md,.markdown,.csv,.json,.html,.htm";
export const ACCEPTED_IMAGES = ".png,.jpg,.jpeg,.webp,.gif";
export const ACCEPTED_FILES = `${ACCEPTED_DOCUMENTS},${ACCEPTED_IMAGES}`;

// Sends a document to be read and resolves to { status, document, message }
export default async function uploadDocument(file) {
  await store.dispatch("auth/setUserID");
  const form = new FormData();
  form.append("userId", store.state.auth.userId);
  form.append("journeyId", store.state.journeyId);
  form.append("document", file, file.name);
  try {
    const response = await fetch(apiUrl("upload/document"), {
      method: "POST",
      body: form,
      credentials: "include",
    });
    const body = await response.json().catch(() => ({}));
    return {
      status: response.status,
      document: body.document,
      message: body.message || "",
    };
  } catch {
    return { status: 0, document: null, message: "" };
  }
}
